import { render, staticRenderFns } from "./ReturnabilityByStaff.vue?vue&type=template&id=0aece6f7&scoped=true"
import script from "./ReturnabilityByStaff.vue?vue&type=script&lang=js"
export * from "./ReturnabilityByStaff.vue?vue&type=script&lang=js"
import style0 from "./ReturnabilityByStaff.vue?vue&type=style&index=0&id=0aece6f7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aece6f7",
  null
  
)

export default component.exports